
namespace GeniuzPOS.CustomReport {

    @Serenity.Decorators.registerClass()
    export class ReportCustomerSurveyTranDtDialog extends Serenity.Extensions.GridEditorDialog<ReportCustomerSurveyTranDtRow> {
        protected getFormKey() { return ReportCustomerSurveyTranDtForm.formKey; }
        // protected getIdProperty() { return ReportCustomerSurveyTranDtRow.idProperty; }
        protected getLocalTextPrefix() { return ReportCustomerSurveyTranDtRow.localTextPrefix; }
        protected getNameProperty() { return ReportCustomerSurveyTranDtRow.nameProperty; }
        // protected getService() { return ReportCustomerSurveyTranDtService.baseUrl; }
        // protected getDeletePermission() { return ReportCustomerSurveyTranDtRow.deletePermission; }
        // protected getInsertPermission() { return ReportCustomerSurveyTranDtRow.insertPermission; }
        // protected getUpdatePermission() { return ReportCustomerSurveyTranDtRow.updatePermission; }

        protected form = new ReportCustomerSurveyTranDtForm(this.idPrefix);

    }
}